import { generateId } from "../strings";

// Overload signatures
export function array(length: number): string[];
export function array<T>(length: number, fn: (index: number) => T): T[];

// Implementation
export function array<T>(length: number, fn?: (index: number) => T) {
	/** If no function is provided, return an empty array */
	const fillFunction = fn ? fn : generateId;

	/** Return */
	return Array.from({ length }).map((_, i) => fillFunction(i));
}
